<template>
  <div class="container">
    <div class="row">
      <h1>Tipos de Requisição</h1>
      <hr>
      <router-link id="btn-add-request-type" :to="{name: 'RequestTypeDetail'}" type="button" class="btn btn-default">
          <span class="glyphicon glyphicon-plus"></span> Adicionar
      </router-link>
      <span class="btn btn-default btn-file">
        <span class="glyphicon glyphicon-upload"></span> Upload
        <input 
          @change="importReqType($event)" 
          type="file" 
          accept=".json, application/json" 
          class="form-control"/>
      </span>
      <br><br>
      <div v-if="loading">
        <loader></loader>
      </div>
      <div v-else>
        <div class="col-sm-1">
            <b-form-select :options="[{text:5,value:5},{text:10,value:10},{text:15,value:15}]" v-model="perPage" class="input-sm"></b-form-select>
          </div>
          <div class="col-sm-9"></div>
          <div class="col-sm-2">
            <b-form-input v-model="filter" placeholder="Digite para pesquisar" class="input-sm"></b-form-input>
          </div>
        </div>
        <b-table id="request-types-table" :items="requestTypes" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" striped hover>
          <span slot="owner" slot-scope="item">
              <span v-if="item.value">{{ item.value.name }}</span>
          </span>
          <span slot="active" slot-scope="item">
              {{ item.value ? 'Ativo' : 'Inativo' }}
          </span>
          <span slot="options" slot-scope="item"> 
            <router-link :to="{name: 'RequestTypeDetail', params: {id: item.item.objectId}}" class="btn btn-primary btn-xs" 
              title="Editar Tipo de Requisição"> 
              <span class="glyphicon glyphicon-edit"></span> 
            </router-link> 
            <button @click="duplicate(item.item.objectId)" class="btn btn-primary btn-xs" title="Criar uma cópia do Tipo de Requisição"> 
              <span class="glyphicon glyphicon-duplicate"></span> 
            </button> 
            <button @click="exportReqType(item.item.objectId)" class="btn btn-primary btn-xs" title="Exportar o tipo de requisição para JSON"> 
              <span class="glyphicon glyphicon-download"></span> 
            </button> 
          </span>
        </b-table>
        <b-pagination size="sm" :total-rows="this.requestTypes.length" :per-page="perPage" v-model="currentPage"/>
      </div>
    </div>
</template>

<script>
  import {
    Parse,
    miniToastr
  } from '../Global'

  import Loader from './util/Loader'
  import { handleParseError } from './util/ErrorHandling'

  export default {
    components: {
      Loader
    },
    data () {
      return {
        requestTypesParse: [],
        requestTypes: [],
        loading: false,
        fields: {
          name: { label: 'Nome', sortable: true },
          description: { label: 'Descrição', sortable: true },
          owner: { label: 'Criador', sortable: true },
          active: { label: 'Status', sortable: true },
          createdAtFmt: {label: 'Data de Criação', sortable: true},
          updatedAtFmt: {label: 'Última Atualização', sortable: true},
          options: {label: 'Opções'}
        },
        currentPage: 1,
        perPage: 5,
        filter: null
      }
    },
    mounted () {
      this.getRequestTypes()
    },
    methods: {
      getRequestTypes () {
        let self = this
        self.loading = true
        Parse.Cloud.run('listRequestTypes').then((results) => {
          self.requestTypesParse = results
          self.requestTypes = results.map(r => {
            let json = r.toJSON()
            if (json.createdAt) {
              let dtFormat = new Date(json.createdAt)
              json.createdAtFmt = dtFormat.toLocaleString('pt-BR')
            }
            if (json.updatedAt) {
              let dtFormat = new Date(json.updatedAt)
              json.updatedAtFmt = dtFormat.toLocaleString('pt-BR')
            }
            return json
          })
          self.loading = false
        }).fail(error => {
          handleParseError(self, error)
          self.loading = false
        })
      },
      duplicate (id) {
        if (confirm('Deseja realmente duplicar o Tipo de Requisição e todos os seus Campos?')) {
          let self = this
          self.loading = true
          let params = { requestId: id }
          Parse.Cloud.run('duplicateRequestType', params).then((results) => {
            self.loading = false
            self.getRequestTypes()
          }).fail(error => {
            handleParseError(self, error)
            self.loading = false
          })
        }
      },
      exportReqType (id) {
        self.loading = true
        Parse.Cloud.run('exportRequestType', {'reqTypeId': id}).then((result) => {
          self.loading = false
          const blob = new Blob([JSON.stringify(result, '', 2)])
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `reqType${id}.json`
          link.click()
        }).fail(error => {
          handleParseError(self, error)
          self.loading = false
        })
      },
      importReqType (event) {
        let self = this
        var reader = new FileReader()
        reader.readAsText(event.target.files[0], 'UTF-8')
        reader.onload = (evt) => {
          const content = evt.target.result
          self.loading = true
          Parse.Cloud.run('importRequestType', {importJson: JSON.parse(content)})
          .then(() => {
            self.loading = false
            miniToastr.success('Importado com sucesso.')
            self.getRequestTypes()
          }).fail((error) => {
            self.loading = false
            handleParseError(self, error)
          })
        }
      }
    }
  }
</script>

<style scoped>

.deactivated {
  text-decoration: line-through !important;
}

</style>



// WEBPACK FOOTER //
// RequestTypeList.vue?383e7b40